import { Card, Flex } from '@grupoboticario/flora-react';

import { Skeleton } from 'components';

export const CardContentSkeleton = () => {
  return (
    <Card data-testid='skeleton-cardcontent'>
      <Flex direction='column' gap='$3'>
        <Skeleton width='100%' height='$23' />
        <Skeleton width='100%' height='$12' />
        <Skeleton width='100%' height='$12' />
      </Flex>
    </Card>
  );
};
